import type { IconData } from '@stacksjs/iconify-core'

export const friedEggBreakfastFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C10.97 1.5 1.5 13.198 1.5 27c0 10.296 6.722 19.5 15.719 19.5c3.278 0 6.296-1.226 8.776-3.273c2.225-1.837 5.197-2.693 7.965-2.693c7.221 0 12.54-7.185 12.54-15.31C46.5 13.395 38.536 1.5 24 1.5\"/><path fill=\"#2859c5\" d=\"M24 11.5c-5.799 0-10.5 4.701-10.5 10.5S18.201 32.5 24 32.5S34.5 27.799 34.5 22S29.799 11.5 24 11.5\"/><path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M22.5 17a1.5 1.5 0 0 1 1.5-1.5a6.5 6.5 0 0 1 6.5 6.5a1.5 1.5 0 0 1-3 0a3.5 3.5 0 0 0-3.5-3.5a1.5 1.5 0 0 1-1.5-1.5\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default friedEggBreakfastFlat
